import styled from 'styled-components';

import {
  Segment as SegmentLayoutComponent,
} from '@playbookux/playbook-web-core';

export const PageContainer = styled.div`
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    padding-top: 0px;
    padding-left: 0px;
    padding-right: 0px;

    width: 850px;
    margin-top: 50px;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 420px ) {
      margin: 100px 30px 0px 30px;
      padding: 10px;
      width: auto;
    };
  }
`;

export const UpperBar = styled.div`
  border-top: 14px solid #477AE9;
  margin-bottom: 10px;
`;

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 50px;
`;

export const Logo = styled.img`
  height: 50px;
`;
